import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const saveContentStatusAccessLog = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveContentClick: builder.mutation({
      query: ({ body, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/educational-content-accessLog`,
          method: "POST",
          data: body,
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSaveContentClickMutation } = saveContentStatusAccessLog;
export default saveContentStatusAccessLog;
